 import Navbar from "../components/Navbar";
 import SecondNavbar from "../components/SecondNavbar";
import Banner from "../components/Banner";
import AboutVibe from "../components/AboutVibe";
import CompignEventSlider from "../components/CompignEventSlider";
import Homecard from "../components/Homecard";
import WhyEcoVibe from "../components/WhyEcoVibe";

import Footer from "../components/Footer"





function Home() {
  return (
    <>
      <Navbar />
      <SecondNavbar/>
      <Banner />
      <AboutVibe/>
      <CompignEventSlider/>
      <Homecard/>
      <WhyEcoVibe/>
      
      <Footer/>
      
      
    </>
  );
}

export default Home;